import { Module } from "vuex";

const managePracticeSignatoriesStoreModule: Module<any, any> = {
  state: {
    selectedPracticeCoreId: null,
    signatoriesUpdatingkey: null,
  },
  mutations: {
    setselectedPracticeCoreId(state, i: number) {
      state.selectedPracticeCoreId = i;
    },
    setSignatoriesUpdatingKey(state, i: string) {
      sessionStorage.setItem('signatoriesUpdatingkey', i);
      state.signatoriesUpdatingkey = i;
    }
  },
  actions: {
    setSelectedPracticeCoreId({ commit }, i: any) {
      commit('setselectedPracticeCoreId', i);
    },
    setSignatoriesUpdatingKey({ commit }, i: string) {
      commit('setSignatoriesUpdatingKey', i);
    }
  },
  getters: {
    getSelectedPracticeCoreId: (state) => state.selectedPracticeCoreId,
    getSignatoriesUpdatingKey: (state) => state.signatoriesUpdatingkey,
  }
}
export default managePracticeSignatoriesStoreModule;
